(function() {
  if (window.LFMNoEmojiInitialized) return;
  window.LFMNoEmojiInitialized = true;

  var excludedTags = {
    SCRIPT: true,
    STYLE: true,
    SVG: true,
    PATH: true,
    CODE: true,
    PRE: true,
    TEXTAREA: true,
    INPUT: true
  };

  var emojiPattern;
  try {
    emojiPattern = new RegExp('[\\p{Emoji_Presentation}\\p{Extended_Pictographic}]\\uFE0F?|[\\uFE0F\\u20E3]', 'gu');
  } catch (error) {
    emojiPattern = /([\u00A9\u00AE](?:\uFE0F)?|[\u203C\u2049\u2122\u2139\u2194-\u21AA\u231A-\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA-\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u27BF\u2934-\u2935\u2B05-\u2B55\u3030\u303D\u3297\u3299](?:\uFE0F)?|[\uD83C-\uDBFF][\uDC00-\uDFFF](?:\uFE0F)?|\uFE0F|\u20E3)/g;
  }

  var allowedSymbolPattern = /[©®™°×±]/g;
  var marker = '__LFM_ALLOWED_SYMBOL__';

  function shouldSkipNode(node) {
    var element = node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement;
    while (element) {
      if (excludedTags[element.tagName]) return true;
      element = element.parentElement;
    }
    return false;
  }

  function normalizeText(value) {
    if (!value || !emojiPattern.test(value)) {
      if (emojiPattern.lastIndex) emojiPattern.lastIndex = 0;
      return value;
    }
    emojiPattern.lastIndex = 0;
    var allowed = [];
    var protectedValue = value.replace(allowedSymbolPattern, function(match) {
      allowed.push(match);
      return marker + (allowed.length - 1) + '__';
    });
	    var cleaned = protectedValue
	      .replace(emojiPattern, '')
	      .replace(/[ \t]{2,}/g, ' ')
	      .replace(/[ \t]*\n[ \t]*/g, '\n')
	      .replace(/\n{3,}/g, '\n\n');
    return cleaned.replace(new RegExp(marker + '(\\d+)__', 'g'), function(match, index) {
      return allowed[Number(index)] || '';
    });
  }

  function cleanTextNode(node) {
    if (!node || node.nodeType !== Node.TEXT_NODE || shouldSkipNode(node)) return;
    var cleaned = normalizeText(node.nodeValue);
    if (cleaned !== node.nodeValue) node.nodeValue = cleaned;
  }

  function cleanElement(root) {
    if (!root || shouldSkipNode(root)) return;
    if (root.nodeType === Node.TEXT_NODE) {
      cleanTextNode(root);
      return;
    }
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function(node) {
        return shouldSkipNode(node) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
      }
    });
    var node;
    while ((node = walker.nextNode())) cleanTextNode(node);
  }

  function init() {
    cleanElement(document.body);
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(cleanElement);
        if (mutation.type === 'characterData') cleanTextNode(mutation.target);
      });
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
